<template>
  <div>
    <c-card title="" class="cardClassDetailForm pre-work-check-target">
      <template slot="card-detail">
        <div class="col-xs-6 col-sm-12 col-md-6 col-lg-6">
          <c-datepicker
            isNotClose
            name="date"
            label="점검일"
            v-model="searchParam.date"
            @datachange="changeDate"
          />
        </div>
        <div class="col-xs-6 col-sm-12 col-md-6 col-lg-6">
          <c-field
            :disabled="disabled"
            :editable="editable"
            class="preWorkDaliyCheckUser"
            name="userId"
            label="점검자"
            v-model="target.userId">
          </c-field>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <c-upload 
            :attachInfo="attachInfo"
            :editable="editable&&!disabled"
            label="첨부파일">
          </c-upload>
        </div>
      </template>
    </c-card>
    <c-table
      ref="table"
      title="월별 일상점검결과"
      gridHeightAuto
      :columns="grid.columns"
      :merge="grid.merge"
      :data="filteringData"
      :editable="editable&&!disabled"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
    >
      <template slot="customFilter">
        <c-radio
          :disabled="disabled"
          :editable="editable"
          :comboItems="filterItems"
          label=""
          name="filter"
          v-model="filter"
        />
      </template>
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable&&!disabled"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="target"
            mappingType="PUT"
            label="저장"
            icon="save"
            @beforeAction="saveInfo"
            @btnCallback="saveInfoCallback" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name==='customCol'">
          <component
            v-if="isOld"
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="editable&&!disabled"
            :isImmShow="true"
            :requestContentsCols="requestContentsCols"
            tableKey="sopPreWorkCheckTargetResultId"
            ibmTaskTypeCd="ITT0000195"
            ibmTaskUnderTypeCd="ITTU000221"
            @imprChange="imprChange"
          />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'preWorkCheckTargetResult',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          sopPreWorkCheckId: '',
        }
      },
    },
    preWorkCheck: {
      type: Object,
      default: function() {
        return {
          sopPreWorkCheckId: '',  // 작업 전 안전점검 일련번호
          plantCd: null,  // 사업장 코드
          pwcPreWorkCheckStepCd: '',  // 작업 전 안전점검 진행상태
          sopPreWorkCheckClassCd: '',  // 작업 전 안전점검 구분 코드
          checkName: '',  // 점검명
          deptCd: '',  // 주관부서
          deptName: '',  // 주관부서
          managerId: '',  // 관리감독자 일련번호
          yearmonth: '',  // 년월
          regUserId: '',  // 등록자 ID
          chgUserId: '',  // 수정자 ID
          targets: [],
          monthResults: [],
          approvalStatusCd: '', // 결재관련 결재상태
          sysApprovalRequestId: '', // 결재관련 결재요청코드
        }
      }
    },
    grid: {
      type: Object,
      default: function() {
        return {
          merge: [
            { index: 0, colName: 'sopPreWorkCheckClassCd' },
            { index: 1, colName: 'checkItemName' },
          ],
          columns: [],
          defaultColumns: [
            {
              name: 'sopPreWorkCheckClassName',
              field: 'sopPreWorkCheckClassName',
              label: '점검<br/>구분',
              align: 'center',
              sortable: true,
              style: 'width:50px',
            },
            {
              name: 'checkItemName',
              field: 'checkItemName',
              label: '점검항목명',
              align: 'left',
              sortable: true,
              style: 'width:80px',
            },
            {
              name: 'checkItemSubName',
              field: 'checkItemSubName',
              label: '점검세부항목명',
              align: 'left',
              sortable: true,
              style: 'width:150px',
            },
          ],
        }
      }
    },
    searchParam: {
      type: Object,
      default: function() {
        return {
          date: '',
        }
      }
    },
    target: {
      type: Object,
      default: function() {
        return {
          sopPreWorkCheckTargetId: '',  // 작업 전 안전점검 대상 일련번호
          sopPreWorkCheckId: '',  // 작업 전 안전점검 일련번호
          deptCd: '',  // 점검부서
          userId: '',  // 점검자
          yearmonth: '',  // 년월
          checkDate: '',  // 점검일
          regUserId: '',  // 등록자 ID
          chgUserId: '',  // 수정자 ID
          results: [],
        }
      }
    },
    attachInfo: {
      type: Object,
      default: function() {
        return {
          isSubmit: '',
          taskClassCd: 'SOP_PRE_WORK_TARGET',
          taskKey: '',
        }
      }
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      filter: 'A',
      filterItems: [
        { code: 'A', codeName: '전체보기', },
        { code: 'M', codeName: '할당된 항목 보기', },
      ],
      editable: true,
      isSave: false,
      saveUrl: '',
      popupOptions: {
        isFull: false,
        width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    // 개선요청 내용 전달
    requestContentsCols() {
      return ['sopPreWorkCheckClassName', 'checkItemName', 'checkItemSubName'];
    },
    // 개선요청 Component
    imprComponent() {
      return () => import(`${'@/pages/common/ibm/mobileTableImpr.vue'}`);
    },
    filteringData() {
      let items = [];
      if (this.target.results && this.target.results.length > 0) {
        if (this.filter === 'M') {
          // 나에게 할당된 점검항목 filtering
          items = this.$_.filter(this.target.results, (result) => {
            return Boolean(result.userId) && result.userId.indexOf(this.$store.getters.user.userId) > -1
          })
        } else {
          // 전체보기
          items = this.target.results;
        }
      }
      return items;
    }
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.saveUrl = transactionConfig.sop.pwc.target.update.url
      // code setting
      // list setting
    },
    changeDate() {
      this.$emit('changeDate')
    },
    // headLinkClick(props, col) {
    //   if (this.isOld) {
    //     this.popupOptions.title = '일별 일상점검 결과 상세 (' + this.preWorkCheck.yearmonth + '-' + col.label + ')'
    //     this.popupOptions.target = () => import(`${"./preWorkCheckTargetDayResult.vue"}`);
    //     this.popupOptions.param = {
    //       sopPreWorkCheckId: this.preWorkCheck.sopPreWorkCheckId,
    //       yearmonth: this.preWorkCheck.yearmonth,
    //       date: this.preWorkCheck.yearmonth + '-' + col.label,
    //       disabled: this.disabled
    //     };
    //     this.popupOptions.visible = true;
    //     this.popupOptions.closeCallback = this.closeResultPopup;
    //   } else {
    //     // 해당 버튼을 누른경우는 필수요소들이 다 있는 경우임으로 더 이상의 유효성평가는 진행 X
    //     window.getApp.$emit('CONFIRM', {
    //       title: '확인',
    //       message: '입력한 정보를 저장한 후 진행가능합니다.\n저장하시겠습니까?', // 저장하시겠습니까?
    //       // TODO : 필요시 추가하세요.
    //       type: 'info', // success / info / warning / error
    //       // 확인 callback 함수
    //       confirmCallback: () => {
    //         this.$emit('save')
    //       },
    //       // 취소 callback 함수
    //       cancelCallback: () => {
    //       },
    //     });
    //   }
    // },
    // closeResultPopup() {
    //   this.popupOptions.target = null;
    //   this.popupOptions.visible = false;
    //   this.$emit('getDetail')
    // },
    saveInfo() {
      if (this.$comm.validTable(this.grid.columns, this.filteringData)) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?', // 저장하시겠습니까?
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.target.chgUserId = this.$store.getters.user.userId
            
            this.isSave = !this.isSave
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveInfoCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('getTargetDetail');
    },
    imprChange() {
      this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
    },
  }
};
</script>
<style lang="sass">
.pre-work-check-target
  label
    padding: 0 !important

</style>